import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { ItemRequestAppKind } from '@/models/app-config/behavior/config/item-detail'
import { AppKind, InquiryKind } from '@ajax/modules/services/inquiry'

export class ArrivalNotificationState {
  static empty(): ArrivalNotificationState {
    return new ArrivalNotificationState(
      'new_stock',
      [],
      [],
      'provisional',
      false
    )
  }

  static create(
    registered: AppKind[],
    inquiryKind: InquiryKind,
    brandEnglishName: string
  ): ArrivalNotificationState {
    const behavior = BehaviorConfig.createFromBrand(brandEnglishName)

    return new ArrivalNotificationState(
      inquiryKind,
      registered,
      behavior.itemDetail.itemRequest.allowAppKind,
      'provisional',
      false
    )
  }

  private constructor(
    private inquiryKind: InquiryKind,
    private registered: AppKind[],
    private allowAppKind: ItemRequestAppKind[],
    private userKind: 'registered' | 'provisional',
    private lineAssociated: boolean
  ) {}

  /**
   * 本会員の意味
   */
  get isRegisteredUser(): boolean {
    return this.userKind === 'registered'
  }

  get isLineAssociatedUser(): boolean {
    return this.lineAssociated
  }

  getButtonLabelFor(appKind: ItemRequestAppKind): string {
    const appKindLabel = this.getAppKindLabel(appKind)
    const inquiryKindLabel = this.inquiryKindLabel

    return this.alreadyRegistered(appKind) ?
      `${inquiryKindLabel}リクエスト済み` :
      `${appKindLabel}で${inquiryKindLabel}をお知らせ`
  }

  allow(appKind: ItemRequestAppKind): boolean {
    return this.allowAppKind.includes(appKind)
  }

  alreadyRegistered(appKind: ItemRequestAppKind): boolean {
    return this.registered.some(r => r === appKind)
  }

  addSuccessfullyRegistered(appKind: AppKind): ArrivalNotificationState {
    this.registered = [
      ...this.registered,
      appKind,
    ]

    return this.clone()
  }

  /**
   * 本会員の意味
   */
  asRegisteredUser(): ArrivalNotificationState {
    this.userKind = 'registered'

    return this.clone()
  }

  asLineAssociatedUser(): ArrivalNotificationState {
    this.lineAssociated = true

    return this.clone()
  }

  get inquiryKindLabel(): string {
    switch (this.inquiryKind) {
      case 'new_stock':
        return '新作'
      case 'restock':
        return '再入荷'
      default:
        throw new Error(`Unexpected item request inquiry kind: ${this.inquiryKind}`)
    }
  }

  private getAppKindLabel(appKind: ItemRequestAppKind): string {
    switch (appKind) {
      case 'mail':
        return 'メール'
      case 'line':
        return 'LINE'
      default:
        throw new Error(`Unexpected item request app kind: ${appKind}`)
    }
  }

  private clone(): ArrivalNotificationState {
    return new ArrivalNotificationState(
      this.inquiryKind,
      this.registered,
      this.allowAppKind,
      this.userKind,
      this.lineAssociated
    )
  }
}
